/*
 * Copyright (c) 2021 Well Solutions SRL. All Rights Reserved.
 * This software is the proprietary information of Well Solutions SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn } from '@angular/forms';
import { ErrorModel } from '../model/error.model';
import { ErrorSeverityEnum } from '../consts/error-severity.enum';

@Directive({
  selector: '[iriroCustomRequiredWithoutZero], [customRequiredWithoutZero]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: CustomRequiredWithoutZeroValidator,
      multi: true,
    }
  ]
})
export class CustomRequiredWithoutZeroValidator implements Validator {
  @Input('customRequiredWithoutZero') fieldName = '';

  validate(control: AbstractControl): ErrorModel | null {
    const funcProperties = {
      field: this.fieldName,
    };
    return _customRequiredWithoutZeroValidation.bind(funcProperties)(control);
  }
}

export const customRequiredWithoutZeroValidation = (
  fieldName = ''
): ValidatorFn => {
  const funcProperties = {
    field: fieldName,
  };

  return _customRequiredWithoutZeroValidation.bind(funcProperties);
};

function _customRequiredWithoutZeroValidation(this: any, control: AbstractControl):
  ErrorModel | null {

  let errors: ErrorModel | null = null;

  if (
    control.value === null ||
    control.value === undefined ||
    control.value === 0
  ) {
    errors = {
      severity: ErrorSeverityEnum.error,
      message: 'required' + this.field,
    };
  }

  return errors ? errors : null;
}
